import { useDispatch, useSelector } from "react-redux";
import { BOLApiTokenInit } from "../../store/BOL/BOLApiTokenSlice";
import { useMsal } from "@azure/msal-react";

export const useIssueBOLToken = (isOnlyAuth = false, isBOCUserIDExists = false) => {
    const dispatch = useDispatch();
    const {accounts} = useMsal();
    const claims = accounts[0]?.idTokenClaims || {};
    const getUserEmail = () =>{
        return (
            claims.email ||
            claims.preferred_username ||
            (Array.isArray(claims.emails) ? claims.emails[0] : null) ||
            claims['signInNames.emailAddress'] ||
            claims['unique_name'] ||
            (claims.name?.includes('@') ? claims.name : null) ||
            null
        ); 
    }
    const { 
        BOLApiToken_data, 
        BOLApiToken_error, 
        BOLApiToken_loading,
        BOLApiToken_success
    } = useSelector(state => state.ROOTREDUCER_RTK.FetchToken);

    // call API initially
    const fetchToken = () => {
        dispatch(BOLApiTokenInit({email: getUserEmail()}));
    };

    return { 
        fetchToken, 
        BOLApiToken_loading, 
        BOLApiToken_error,
        BOLApiToken_success,
        BOLApiToken_data
    };
};
